var exports = {
  "JW": "SignalStrengthIcon.module__svg___SndoNl",
  "wL": "SignalStrengthIcon.module__green___SndoNl",
  "D9": "SignalStrengthIcon.module__yellow___SndoNl",
  "T_": "SignalStrengthIcon.module__orange___SndoNl",
  "wv": "SignalStrengthIcon.module__red___SndoNl",
  "Xe": "SignalStrengthIcon.module__tertiary___SndoNl",
  "cQ": "SignalStrengthIcon.module__tertiaryMuted___SndoNl",
};

module.exports = exports;
